import { render } from "./ConfigurationsDataList.vue?vue&type=template&id=0ed1c564&ts=true"
import script from "./ConfigurationsDataList.vue?vue&type=script&lang=ts"
export * from "./ConfigurationsDataList.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__